import { Auth } from 'aws-amplify';
import messages from '../../messages';

export async function resendVerifyEmailCode(email: string, snackbar: any) {
  try {
    await Auth.resendSignUp(email);
    snackbar.show(messages.auth.resentVerifyEmailCode, 'success');
  } catch (error) {
    snackbar.show(error.message, 'error');
  }
}
